import { Image, Avatar as AvatarComponent } from '@mantine/core'

import grayface from '../../assets/images/grayface.svg'

export const Avatar = AvatarComponent.extend({
  defaultProps: {
    children: <Image src={grayface} />,
  },
})
